export const escapeQuotes = str => str.replace(/"/g, '\\"').replace(/'/g, "\\'");

export const normalizeWhitespace = str => (typeof str === "string" ? str.replace(/\s+/g, " ").trim() : "");
